import axios from "@/api/axiosInstance";
import { GetBillingInvoicesResponse } from "./types";

export const getBillingInvoices = async (
  signal?: AbortSignal,
): Promise<GetBillingInvoicesResponse> => {
  const response = await axios.get<GetBillingInvoicesResponse>(
    "/api/private/billing/invoices",
    { signal },
  );
  return response.data;
};